import { all, call, CallEffect, fork, put, PutEffect, takeEvery } from "redux-saga/effects";
import { ActionTypes } from "../../constants/ActionTypes";
import { ShowError, ShowSuccess } from "../../helper/Alert";
import { fetchError, onDeleteDraftSuccess } from "../actions";
import { CallHistoryMethodAction, goBack } from "connected-react-router";
import faMessage from "../../../src/lngProvider/locales/fa_IR.json";
import enMessage from "../../../src/lngProvider/locales/en_US.json";
import { defineMessages } from "react-intl";
import FaraGostarDynamicHttp from "../../api/FaraGostarDynamicHttp";
import { AxiosResponse } from "axios";

// deleteDraft
const deleteDraftApi = async (letterCode: string, folderCode: string) => {
    let http = await FaraGostarDynamicHttp();
    return await http.post(`Letter/DeleteLetter`, {
        letterCode: letterCode,
        folderCode: folderCode,
    });
}

function* deleteDraftRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, CallHistoryMethodAction<[]> | void, AxiosResponse<any>> {
    const LocaleMessages = localStorage.getItem("language") === 'fa-IR' ? faMessage : enMessage;
    const messages = defineMessages(LocaleMessages);
    try {
        yield call(deleteDraftApi, action.payload.letterCode, action.payload.folderCode);
        // yield put(onDeleteDraftSuccess());
        ShowSuccess(messages["messages.operationWasSuccessful"], "");
        return goBack();

    } catch (error) {
        return ShowError("", error);
    }
}

export function* deleteDraft() {
    yield takeEvery(ActionTypes.DELETE_DRAFT, deleteDraftRequest);
}

export default function* rootSaga() {
    yield all([fork(deleteDraft)]);
}
